<template>
  <div :value="value">
    <div class="page__hd">
      <h1 class="page__title">
        完善个人在线签名，请申请人在白色区域手写输入申请人名字
      </h1>
      <p class="page__desc">
        提示：在法律援助审批完成后，需要您的在线签名已完成在线审批材料的流程。
      </p>
    </div>
    <div
      v-if="is_set"
      class="preview-signature hair-top hair-bottom"
    >
      <img
        height="200px"
        :src="img"
      >
    </div>
    <VueSignaturePad
      v-else
      ref="signaturePad"
      save-type="image/png"
      height="200px"
      class="signature-area hair-top hair-bottom"
    />
    <div class="page__bd page__bd_spacing">
      <div
        v-if="is_set"
        class="weui-flex btn-group"
      >
        <div class="weui-flex__item">
          <a
            href="/#/register"
            class="weui-btn weui-btn_primary"
          >返回</a>
        </div>
        <div class="weui-flex__item">
          <a
            href="javascript:;"
            class="weui-btn weui-btn_default"
            @click="reset"
          >重新设置</a>
        </div>
      </div>

      <div
        v-else
        class="weui-flex btn-group"
      >
        <div class="weui-flex__item">
          <a
            href="javascript:;"
            class="weui-btn weui-btn_primary"
            @click="save"
          >确定</a>
        </div>
        <div class="weui-flex__item">
          <a
            href="javascript:;"
            class="weui-btn weui-btn_default"
            @click="undo"
          >撤销</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Setsignature',
  props: ['value'],
  data () {
    return {
      is_set: false,
      img: '',
      url: ''
    }
  },
  mounted () {
    if (this.value) {
      this.img = this.value
      this.is_set = true
    }
  },
  methods: {
    save () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (isEmpty) {
        console.log('isEmpty')
        return
      }
      $.post('/api/base64img/upload/', { basedata: data.replace('data:image/png;base64,', '') },  // eslint-disable-line
        function (results) {
          console.log(results)
          this.url = results.result.url
          this.$emit('input', this.url)
        }.bind(this)
      )
      this.is_set = true
      this.img = data
    },
    undo () {
      this.$refs.signaturePad.undoSignature()
    },
    reset () {
      const _this = this
      this.$w.dialog({
        title: '是否需要重新设置签名？',
        buttons: [
          {
            label: '返回',
            type: 'default'
          },
          {
            label: '重设',
            type: 'primary',
            onClick () {
              _this.is_set = false
            }
          }
        ]
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.signature-area
  background #fff
.preview-signature
  height 200px
  background #fff
.btn-group
  padding-top 30px
  a
    margin 0 5px
.btn-group .weui-btn + .weui-btn
  margin-top 15px
</style>
